import React, {Component} from "react";

import {Button, Col, Descriptions, Input, Row} from "antd";
import Highlighter from "react-highlight-words";

import {DataCard} from "./helpers/cards/Card";
import {MaterialBlock} from "./helpers/cards/MaterialBlock";
import {StandardTable} from "./helpers/TablePanel";
import api from "../api";
import {openLinkInNewTab} from "../helpers";
import {properties} from "../properties";

export class ListOfMaterials extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: "",
			query: "",
			prevQuery: "",
			total: 0,
			page: 1,
			options: [],
			filters: {},
			size: 50,
			results: [],
			loading: false,
		};
	}

	componentDidMount() {
		const p = window.location.search;
		const params = new URLSearchParams(p);
		const search = params.get("search") || "";
		this.search(null, search);
		this.getFilterOptions();
	}

	getFilterOptions() {
		api.get(`${this.props.baseUrl}/table/filter/options?field_name=Type`)
			.then(json => this.setState({options: json.data}))
			.catch(error => console.log(error));
	}

	search = (
		event,
		query = this.state.value,
		page = this.state.page,
		size = this.state.size,
		filters = this.state.filters,
	) => {
		event && event.preventDefault();

		const cleanQuery = query ? query.trim() : "";

		this.setState({loading: true});
		if (cleanQuery !== this.state.prevQuery || size !== this.state.size) {
			page = 1;
		}
		api.post(`${this.props.baseUrl}?query=${cleanQuery}&page=${page}&step=${size}`, {filters: filters})
			.then(json =>
				this.setState({
					results: json.data.items,
					query: cleanQuery,
					prevQuery: cleanQuery,
					total: json.data.total,
					page: page,
					size: size,
					filters: filters,
				}),
			)
			.catch(error => console.log(error))
			.finally(() => this.setState({loading: false}));
	};

	onChange = (newPagination, _filters, _sorter) => {
		this.search(null, this.state.value, newPagination.current, newPagination.pageSize, _filters);
	};

	columns = () => {
		const from = `${window.location.href}?search=${this.state.query}`;
		return [
			{
				title: "Material",
				dataIndex: "material",
				key: "material",
				render: text => (
					<MaterialBlock material={text}>
						<Highlighter
							style={{color: properties.kbrColors.pantone301Blue, cursor: "pointer"}}
							onClick={() => openLinkInNewTab(this.props.createLink(text, from))}
							highlightStyle={{backgroundColor: "#ffc069", padding: 0}}
							searchWords={[this.state.query]}
							autoEscape
							textToHighlight={text ? text.toString() : null}
						/>
					</MaterialBlock>
				),
			},
			{
				title: "Material Description",
				dataIndex: "description",
				key: "Material Description",
				render: text => (
					<Highlighter
						highlightStyle={{backgroundColor: "#ffc069", padding: 0}}
						searchWords={[this.state.query]}
						autoEscape
						textToHighlight={text ? text.toString() : null}
					/>
				),
			},
			{
				title: "Movement Class",
				dataIndex: "Type",
				key: "Type",
				filters: this.state.options.map(v => ({
					text: v,
					value: v,
				})),
			},
			{
				title: "Open",
				dataIndex: "material",
				key: "Material",
				render: material => (
					<div
						className={"beautiful-link"}
						onClick={() => openLinkInNewTab(this.props.createLink(material, from))}>
						Open
					</div>
				),
			},
		];
	};

	render() {
		const style = {
			height: "80vh",
			maxHeight: "80vh",
		};

		return (
			<>
				<DataCard style={style}>
					<Row style={{padding: 10}}>
						<Col span={4} />
						<Col span={16}>
							<Input.Group compact>
								<Input
									style={{width: "calc(100% - 200px)"}}
									value={this.state.value}
									onChange={event => this.setState({value: event.target.value})}
									onPressEnter={this.search}
									placeholder="Input the material"
								/>
								<Button
									style={{backgroundColor: properties.kbrColors.pantone301Blue, color: "white"}}
									onClick={this.search}>
									Submit
								</Button>
							</Input.Group>
						</Col>
						<Col span={4} />
					</Row>
					<Row style={{padding: 10}}>
						{this.state.query && (
							<Descriptions>
								<Descriptions.Item label="Search Query">{this.state.query}</Descriptions.Item>
							</Descriptions>
						)}
						<StandardTable
							size={"small"}
							loading={this.state.loading}
							style={{width: "100%"}}
							total={this.state.total}
							currentPage={this.state.page}
							columns={this.columns()}
							scroll={500}
							onChange={this.onChange}
							pageSize={this.state.size}
							data={this.state.results}
						/>
					</Row>
				</DataCard>
			</>
		);
	}
}
